"use strict";

exports.__esModule = true;
exports.DurationAxis = DurationAxis;
var _react = _interopRequireDefault(require("react"));
var _Axis = require("./Axis");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Shows an axis with duration ticks.
 */
function DurationAxis(props) {
  return /*#__PURE__*/_react["default"].createElement(_Axis.Axis, _extends({}, props, {
    tickFormat: _Utils.formatDuration
  }));
}